import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const portsAdapter = getAdapter();

const portsSlice = createSlice({
  name: 'ports',
  initialState: portsAdapter.getInitialState(),
  reducers: {
    setPorts: (state, { payload: { ports } }) => {
      portsAdapter.setAll(state, ports);
    },
  },
});

const selectors = portsAdapter.getSelectors(({ ports }) => ports);

export const getPorts = (state) => selectors.selectAll(state);

export const {
  setPorts,
} = portsSlice.actions;

export default portsSlice.reducer;
